export const RESOURCE_TYPE_NEXTGEN_PROJECT_SETTINGS_CUSTOM_FILTERS =
	'NEXTGEN_PROJECT_SETTINGS_CUSTOM_FILTERS';
